import React from 'react';
import { Col } from 'react-grid-system';
import styled from 'styled-components';

const Column = styled(Col)`
padding-top: 2rem;
padding-bottom: 1rem;
`;

export default Column;